import { ReactNode } from "react";
import { SxProps, Theme } from "@mui/material/styles";
import Text from "@/components/Text";
import {
  SECTION_GROUP_HEADING_COLOR,
  SECTION_GROUP_HEADING_FONT_SIZE,
} from "../readmission-f2f-constant";

export interface SectionGroupHeadingProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const SectionGroupHeading = ({ children, sx }: SectionGroupHeadingProps) => (
  <Text
    size={SECTION_GROUP_HEADING_FONT_SIZE}
    fontWeight="bold"
    c={SECTION_GROUP_HEADING_COLOR}
    sx={[
      { textTransform: "uppercase", mt: 1 },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Text>
);

export default SectionGroupHeading;
